import React from 'react';

import {Text} from '#component/base';

import * as css from '../BenefitsList.css';

export const MembersBenefitsList = () => {
  return (
    <div>
      <Text className={css.BenefitLabel} as="h4" variant="body" color="burgundy">
        Benefits
      </Text>
      <Text className={css.BenefitLabel} color="doveGray">
        Enjoy 15% off supplements each month, bi-annual epigenetic age testing, and access to
        personalized action plans with your Membership
      </Text>
    </div>
  );
};
